// ESPAÑOL — traducción de cortesía. Solo la versión francesa da fe (véase fr.js).

import { COURRIEL, TELEPHONE, adresseVendeur, encadreIdentite } from './identite';

const ADRESSE = adresseVendeur('Bélgica');
const TRADUCTION =
  'Esta traducción se ofrece para su comodidad. En caso de discrepancia, solo la versión francesa tiene valor legal.';

export default {
  cgv: {
    seoTitre: 'Condiciones Generales de Venta',
    seoDescription:
      'Condiciones generales de venta de MirumGames: pedido, precios, pago, derecho de desistimiento de 14 días, entrega y garantías.',
    titre: 'Condiciones Generales de Venta',
    maj: 'Última actualización: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Artículo 1: Generalidades',
        blocs: [
          { p: 'Todo pedido realizado en MIRUMGAMES.COM implica la aceptación previa de estas condiciones generales. El cliente reconoce haber leído y aceptado su contenido sin reservas.' },
        ],
      },
      {
        titre: 'Artículo 2: Objeto',
        blocs: [
          { p: 'Estas condiciones generales definen los derechos y obligaciones de las partes en la venta en línea de los productos y servicios que MirumGames.com ofrece al consumidor.' },
        ],
      },
      {
        titre: 'Artículo 3: Precios y Pago',
        blocs: [
          { p: 'Los precios se indican en euros e incluyen el IVA aplicable. No incluyen los gastos de envío, que se facturan aparte. El pago íntegro se realiza al confirmar el pedido.' },
          { p: 'MirumGames.com acepta pagos con tarjeta a través de STRIPE, un proveedor de pago seguro certificado.' },
          { p: 'Cada pedido pagado da lugar a una factura a nombre del comprador, disponible en la página de confirmación del pedido, mediante el enlace del correo de confirmación y, para los clientes con cuenta, en «Mis pedidos». Stripe envía además un recibo de pago por correo electrónico.' },
        ],
      },
      {
        titre: 'Artículo 4: Derecho de Desistimiento',
        blocs: [
          { p: 'Todo consumidor particular dispone de 14 días para devolver los productos que no le convengan. El plazo empieza el día de la entrega.' },
          { p: 'Condiciones de devolución:' },
          {
            liste: [
              'Los productos deben devolverse en su embalaje original y en perfecto estado para su reventa',
              'No se aceptarán productos con señales de uso',
              'Los gastos de devolución corren a cargo del consumidor',
              'El reembolso se efectuará por transferencia bancaria en un plazo de 15 días',
            ],
          },
        ],
      },
      {
        titre: 'Artículo 5: Garantía Comercial',
        blocs: [
          { p: 'MirumGames.com garantiza los productos frente a vicios ocultos conforme a la legislación belga. MirumGames.com no es la fabricante de los artículos ofrecidos y declina toda responsabilidad por los daños causados por un defecto del producto.' },
          { p: 'La responsabilidad del vendedor se limita al cambio o al reembolso del producto defectuoso.' },
        ],
      },
      {
        titre: 'Artículo 6: Disponibilidad de los Productos',
        blocs: [
          { p: 'Las ofertas están sujetas a la disponibilidad de existencias. Las imágenes, colores, dimensiones y pesos son meramente informativos y no contractuales. MirumGames.com declina toda responsabilidad por las variaciones en las características del producto.' },
        ],
      },
      {
        titre: 'Artículo 7: Entrega',
        blocs: [
          { p: 'Los productos se entregan en la dirección indicada por el consumidor en el formulario de pedido. Debe ser una dirección física (no un apartado de correos).' },
          { p: 'Enviamos a Bélgica, Francia, Luxemburgo, los Países Bajos, Alemania y España. Plazos medios de entrega:' },
          {
            liste: [
              'Luxemburgo, Bélgica, Países Bajos: 1 a 2 días hábiles',
              'Francia, Alemania: 2 a 4 días hábiles',
              'España: 4 a 5 días hábiles',
            ],
          },
          { p: 'Nota: hay que añadir el plazo de preparación (1 día hábil de media).' },
        ],
      },
      {
        titre: 'Artículo 8: Conformidad de la Entrega',
        blocs: [
          { p: 'Al recibir el pedido, el consumidor debe comprobar que los productos coinciden con el albarán. Todo defecto debe anotarse a mano en el albarán de entrega.' },
          { p: 'Cualquier anomalía (producto ausente, dañado, etc.) debe comunicarse a MirumGames.com en las 96 horas siguientes al aviso de expedición.' },
        ],
      },
      {
        titre: 'Artículo 9: Responsabilidad',
        blocs: [
          { p: 'MirumGames.com no se hace responsable de los daños causados por un uso indebido o una manipulación inadecuada de los productos después de la entrega.' },
        ],
      },
      {
        titre: 'Artículo 10: Legislación Aplicable',
        blocs: [
          { p: 'Estas condiciones generales se rigen por el derecho belga. En caso de litigio, se invita al consumidor a contactar primero con MirumGames.com para encontrar una solución amistosa.' },
        ],
      },
      {
        titre: 'Aviso Legal',
        blocs: [
          { p: 'Para consultar los datos legales completos de la empresa (contacto, IVA, etc.), visite nuestra <a href="/legal" class="text-blue-600 hover:text-blue-800 underline">página de Aviso Legal</a>.' },
          { p: 'En los pedidos cuyo pago se recibió hasta el 22/09/2026 inclusive (hora de Bélgica), la vendedora es Charlotte Ansiaux (BCE 1000.107.018), que sigue siéndolo; en los pedidos cuyo pago se recibe a partir del 23/09/2026, el vendedor es Sébastien Schoonjans.' },
        ],
      },
    ],
  },

  confidentialite: {
    seoTitre: 'Política de Privacidad',
    seoDescription:
      'Política de privacidad de MirumGames: datos recogidos, uso, cookies, medición de audiencia anónima y sus derechos según el RGPD.',
    titre: 'Política de Privacidad',
    maj: 'Última actualización: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: '1. Recogida de Datos Personales',
        blocs: [
          { p: 'MirumGames.com recoge los datos personales necesarios para:' },
          {
            liste: [
              'Tramitar su pedido (nombre, dirección, correo electrónico, teléfono)',
              'Enviarle las confirmaciones de pedido y los avisos de entrega',
              'Gestionar su cuenta de cliente',
              'Enviarle nuestros boletines (con su consentimiento)',
              'Mejorar nuestros servicios',
            ],
          },
        ],
      },
      {
        titre: '2. Uso de los Datos',
        blocs: [
          { p: 'Sus datos se utilizan únicamente para los fines enumerados arriba. MirumGames.com nunca comunica sus datos a terceros sin su consentimiento explícito.' },
          { p: 'Las únicas excepciones son:' },
          {
            liste: [
              'Los proveedores logísticos, para la entrega',
              'STRIPE, para el tratamiento de los pagos',
              'Las autoridades públicas, cuando la ley lo exija',
            ],
          },
        ],
      },
      {
        titre: '3. Cookies',
        blocs: [
          { p: 'MirumGames.com utiliza cookies para mejorar su experiencia, en particular para:' },
          {
            liste: [
              'Recordar sus preferencias de navegación',
              'Gestionar su cesta de la compra',
              'Personalizar su experiencia',
            ],
          },
          { p: 'Puede desactivar las cookies en cualquier momento desde los ajustes de su navegador. Ello puede, sin embargo, afectar al funcionamiento del sitio.' },
          { p: '<strong>Medición de audiencia:</strong> utilizamos un contador de visitas propio, sin cookie y sin datos personales. Ni su dirección IP ni su historial de navegación se conservan: solo se producen estadísticas agregadas y anónimas (páginas vistas, visitantes por día). No permite seguirle de un día para otro ni de un sitio a otro, y puede rechazarlo en cualquier momento desde el enlace «Gestionar mis cookies» al final de la página.' },
        ],
      },
      {
        titre: '4. Sus Derechos (RGPD)',
        blocs: [
          { p: 'Como residente en Europa, usted tiene los siguientes derechos:' },
          {
            liste: [
              '<strong>Derecho de acceso:</strong> puede solicitar el acceso a sus datos personales',
              '<strong>Derecho de rectificación:</strong> puede corregir datos inexactos',
              '<strong>Derecho al olvido:</strong> puede solicitar la supresión de sus datos',
              '<strong>Derecho de limitación:</strong> puede limitar el tratamiento de sus datos',
              '<strong>Derecho a la portabilidad:</strong> puede recibir sus datos en un formato estructurado',
              '<strong>Derecho de oposición:</strong> puede oponerse al tratamiento de sus datos',
            ],
          },
          { p: `Para ejercer estos derechos, escriba a ${COURRIEL}.` },
        ],
      },
      {
        titre: '5. Seguridad de los Datos',
        blocs: [
          { p: 'MirumGames.com aplica medidas de seguridad técnicas y organizativas adecuadas para proteger sus datos:' },
          {
            liste: [
              'Cifrado SSL/TLS de todas las conexiones',
              'Acceso restringido a los datos personales',
              'Copias de seguridad periódicas',
              'Cumplimiento del RGPD',
            ],
          },
        ],
      },
      {
        titre: '6. Plazo de Conservación',
        blocs: [
          { p: 'Sus datos personales se conservan durante el tiempo necesario para:' },
          {
            liste: [
              'La ejecución de su pedido y de las garantías',
              'El cumplimiento de las obligaciones legales (en especial fiscales)',
              'La gestión de su cuenta de cliente',
            ],
          },
          { p: 'Transcurrido ese periodo, sus datos se suprimen o se anonimizan.' },
        ],
      },
      {
        titre: '7. Terceros',
        blocs: [
          { p: 'MirumGames.com puede compartir sus datos con los siguientes proveedores:' },
          {
            liste: [
              '<strong>STRIPE</strong>: para el tratamiento de los pagos',
              '<strong>Sendcloud</strong>: para la gestión de envíos y entregas',
              '<strong>Sentry</strong>: para la notificación de errores técnicos del sitio. Solo se transmite la información necesaria para diagnosticar una avería; no se realiza ninguna grabación de su navegación.',
              '<strong>Alojamiento</strong>: para almacenar el sitio y los datos',
            ],
          },
          { p: 'Todos estos proveedores están obligados a respetar la confidencialidad de sus datos.' },
        ],
      },
      {
        titre: '8. Contacto',
        blocs: [
          { p: 'Para cualquier cuestión relativa a su privacidad, contacte con:' },
          { p: `<strong>Responsable del tratamiento:</strong> Sébastien Schoonjans (MirumGames.com)<br /><strong>Correo:</strong> ${COURRIEL}<br /><strong>Dirección:</strong> ${ADRESSE}` },
          { p: 'Los datos de las cuentas de cliente existentes fueron transferidos a Sébastien Schoonjans, junto con la actividad del sitio, el 23/09/2026.' },
        ],
      },
    ],
  },

  mentions: {
    seoTitre: 'Aviso Legal',
    seoDescription:
      'Aviso legal de MirumGames: datos de la empresa, titular del sitio, número de IVA y datos de contacto.',
    titre: 'Aviso Legal',
    maj: 'Última actualización: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Datos de la Empresa',
        blocs: [
          {
            encadre: encadreIdentite({
              nom: 'Nombre de la empresa',
              statut: 'Forma jurídica',
              statutValeur: 'empresario individual autónomo (persona física)',
              adresse: 'Dirección',
              pays: 'Bélgica',
              bce: 'Número de empresa (BCE)',
              tva: 'Número de IVA',
              email: 'Correo',
              telephone: 'Teléfono',
              sep: ':',
            }),
          },
        ],
      },
      {
        titre: 'Director de la Publicación',
        blocs: [
          { p: '<strong>Sébastien Schoonjans</strong><br />Responsable de la publicación del sitio MirumGames.com' },
        ],
      },
      {
        titre: 'Alojamiento del Sitio',
        blocs: [
          { p: 'MirumGames.com está alojado por:<br /><strong>Cloudflare Pages</strong> (interfaz pública)<br /><strong>Servidor dedicado</strong> (aplicación y base de datos)<br /><br />Los datos se alojan en la Unión Europea y se tratan conforme al RGPD.' },
        ],
      },
      {
        titre: 'Propiedad Intelectual',
        blocs: [
          { p: 'Todo el contenido del sitio MirumGames.com (textos, imágenes, ilustraciones, logotipos, vídeos, etc.) está protegido por las leyes de propiedad intelectual.' },
          { p: 'Queda prohibida toda reproducción, representación, modificación, publicación o adaptación de la totalidad o parte del sitio, por cualquier medio, sin la autorización previa por escrito del editor del sitio, Sébastien Schoonjans.' },
        ],
      },
      {
        titre: 'Impuestos y Tasas',
        blocs: [
          { p: 'Le informamos de que nuestros precios incluyen los impuestos y tasas vigentes en Bélgica. La legislación varía según el país.' },
          { p: 'El comprador comprobará si en su país de residencia se adeudan otros impuestos o tasas y, en su caso, deberá abonar las tasas, impuestos y cargas de cualquier naturaleza relativos a los productos que haya importado a su país.' },
        ],
      },
      {
        titre: 'Limitación de Responsabilidad',
        blocs: [
          { p: 'El editor del sitio procura garantizar la exactitud y la actualización de la información publicada en este sitio, y se reserva el derecho de corregir su contenido en cualquier momento y sin previo aviso.' },
          { p: 'No obstante, el editor del sitio no puede garantizar la exactitud, la precisión ni la exhaustividad de la información puesta a disposición en este sitio.' },
        ],
      },
      {
        titre: 'Cookies y Datos Personales',
        blocs: [
          { p: 'Para cualquier información sobre el uso de cookies y la protección de sus datos personales, consulte nuestra <a href="/privacy" class="text-blue-600 hover:text-blue-800 underline">Política de Privacidad</a>.' },
        ],
      },
      {
        titre: 'Legislación Aplicable',
        blocs: [
          { p: 'El presente aviso legal se rige por el derecho belga. En caso de litigio, el consumidor se dirigirá en primer lugar a MirumGames.com para obtener una solución amistosa.' },
          { p: 'En su defecto, dicho litigio se someterá a la competencia exclusiva de los tribunales belgas competentes.' },
        ],
      },
      {
        titre: 'Contacto',
        blocs: [
          { p: `Para cualquier cuestión relativa a este aviso legal, puede contactarnos en:<br /><strong>Correo:</strong> ${COURRIEL}<br /><strong>Dirección:</strong> ${ADRESSE}<br /><strong>Teléfono:</strong> ${TELEPHONE}` },
        ],
      },
    ],
  },

  paiement: {
    seoTitre: 'Seguridad de los Pagos',
    seoDescription:
      'Seguridad de los pagos en MirumGames: transacciones gestionadas por Stripe, cifrado SSL/TLS, certificación PCI-DSS y consejos prácticos.',
    titre: 'Seguridad de los Pagos',
    maj: 'Última actualización: 18/02/2024',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Pago mediante STRIPE',
        blocs: [
          { p: 'La seguridad de las transacciones bancarias es primordial. MirumGames.com ha optado por apoyarse en la experiencia de STRIPE para garantizar la máxima seguridad de sus pagos.' },
        ],
      },
      {
        titre: '¿Es seguro pagar en MirumGames?',
        blocs: [
          { p: 'Sí. Durante la fase de pago, la totalidad de la transacción se realiza mediante STRIPE en modo cifrado. Usted abandona brevemente MirumGames.com, con total transparencia, para introducir sus datos bancarios.' },
          { p: 'Esto garantiza que:' },
          {
            liste: [
              'MirumGames.com nunca conocerá su número de tarjeta ni tendrá acceso a sus datos bancarios',
              'MirumGames.com no conocerá los detalles de sus transacciones: solo se nos transmiten el importe total y el número de pedido',
              'Sus datos bancarios son tratados exclusivamente por STRIPE, un proveedor certificado y de confianza',
            ],
          },
        ],
      },
      {
        titre: '¿Qué medidas de seguridad aplica STRIPE?',
        blocs: [
          { p: 'STRIPE utiliza el sistema de cifrado estandarizado conocido como «protocolo SSL» (Secure Sockets Layer).' },
          { p: 'Cuando esté en la página de pago, compruebe estos indicadores de seguridad:' },
          {
            liste: [
              '<strong>Icono de seguridad:</strong> debe aparecer un candado cerrado en la esquina de su navegador',
              '<strong>Barra de direcciones:</strong> la URL debe empezar por «https://» (y no «http://»)',
              'La «s» de https indica una conexión segura y cifrada',
            ],
          },
          { p: 'Si aparece un mensaje de advertencia, es que está pasando de un modo cifrado a uno no cifrado (o al revés). En ese caso, verifíquelo antes de introducir datos confidenciales.' },
        ],
      },
      {
        titre: 'Certificaciones de STRIPE',
        blocs: [
          { p: 'STRIPE cumple las normas más estrictas:' },
          {
            liste: [
              '<strong>PCI-DSS</strong> (Payment Card Industry Data Security Standard): certificación de máxima seguridad para pagos con tarjeta',
              '<strong>RGPD</strong>: cumplimiento total de la normativa europea',
              '<strong>ISO 27001</strong>: certificación de gestión de la seguridad de la información',
              '<strong>SOC 2 Tipo II</strong>: auditoría independiente de seguridad y cumplimiento',
            ],
          },
        ],
      },
      {
        titre: 'Recomendaciones de Seguridad',
        blocs: [
          { p: 'Para garantizar su seguridad al pagar:' },
          {
            liste: [
              '✓ Utilice siempre la última versión de su navegador',
              '✓ Pague solo a través de conexiones seguras (no en wifi público sin protección)',
              '✓ Compruebe siempre que el candado esté cerrado y que la URL empiece por «https://»',
              '✓ No comparta nunca sus datos de pago por correo electrónico ni por teléfono',
              '✓ Revise con regularidad su extracto bancario para detectar actividad sospechosa',
            ],
          },
        ],
      },
      {
        titre: '¿Qué ocurre después del pago?',
        blocs: [
          { p: 'Una vez validado el pago:' },
          {
            liste: [
              'Recibe una confirmación de pedido por correo electrónico',
              'MirumGames.com recibe únicamente el importe total y su número de pedido',
              'STRIPE almacena sus datos de pago de forma segura',
              'Su pedido se prepara y se envía',
            ],
          },
        ],
      },
      {
        titre: 'En caso de Problema',
        blocs: [
          { p: 'Si detecta actividad sospechosa en su cuenta:' },
          {
            liste: [
              'Contacte de inmediato con su banco',
              `Envíe un correo a ${COURRIEL} con los detalles del problema`,
              'Comunique el problema directamente a STRIPE',
            ],
          },
        ],
      },
      {
        titre: 'Preguntas Frecuentes',
        blocs: [
          { p: '<strong>P: ¿Guarda MirumGames.com los datos de mi tarjeta?</strong><br />R: No, en absoluto. Solo STRIPE gestiona sus datos bancarios.' },
          { p: `<strong>P: ¿Cómo puedo suprimir mis datos de pago?</strong><br />R: Escriba a ${COURRIEL} para solicitar la supresión de sus datos.` },
          { p: '<strong>P: ¿Puedo usar varios métodos de pago?</strong><br />R: Sí. STRIPE acepta tarjetas de crédito, de débito y otros métodos según su ubicación.' },
        ],
      },
      {
        titre: 'Más Información',
        blocs: [
          { p: 'Para más detalles sobre la seguridad de STRIPE, visite: <a href="https://stripe.com/security" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">stripe.com/security</a>' },
        ],
      },
    ],
  },
};
